import React from "react";
import RequestPageMUI from "./RequestPageMUI";

const General = () => {
    return (
        <RequestPageMUI 
            title="General Enquiries"
            fetchUrl="/get-general-enquiries"
            editEndpoint="update-general-enquiries"
            deleteEndpoint="delete-general-enquiries"
            statusEndpoint="update-general-enquiries"
            dateFields={['created_at', 'updated_at']}
            hiddenFields={['ip_address']} // Hide sensitive/internal fields
            // Add filter if needed
            // filterField="category"
            // filterValue="general"
            // showFilter={true}
        />
    );
};

export default General;